import React from 'react';
import Button from '../../../../Components/Button/Button';
import { Theme } from '../../../../Enums/Theme.enum';
import LinkButton from '../../../../Components/Button/LinkButton';
import styles from './EArchiveGroupToolbar.module.scss';

interface Props {
	onSubmit: () => void;
	onCancel: () => void;
	submitText: string;
	submitTheme?: Theme;
	cancelText: string;
	cancelTheme?: Theme;
}

const EArchiveGroupToolbar = ({
	onSubmit,
	onCancel,
	submitText,
	submitTheme = Theme.GREEN,
	cancelText,
	cancelTheme = Theme.RED,
}: Props) => {
	return (
		<div className={styles.wrapper}>
			<Button onClick={onSubmit} theme={submitTheme} title={submitText} />
			<LinkButton onClick={onCancel} theme={cancelTheme} title={cancelText} />
		</div>
	);
};

export default EArchiveGroupToolbar;
